import script from "./SSOLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./SSOLoader.vue?vue&type=script&setup=true&lang=js"

import "./SSOLoader.vue?vue&type=style&index=0&id=466dd334&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466dd334"]])

export default __exports__